export default "__VITE_ASSET__CzJ_hAVx__"